// 🧭 D'où vient l'élève qui ouvre la fiche d'un prof (statistiques v2, tour 46) : recherche du site
// (la recherche, les profs de l'accueil), favoris (page des favoris, favoris du tableau de bord),
// lien direct (lien partagé, adresse tapée, autre site) ou lien partenaire (?via=partenaire, pour
// le futur bouton partenaire). Le lien du site porte l'origine dans l'état de navigation, jamais
// dans l'adresse : une adresse copiée ou partagée compte comme un lien direct.
// L'onglet retient la dernière origine de chaque fiche (sessionStorage) pour la demande ou la
// réservation qui suit, même en passant par la page de réservation. Rien d'autre n'est gardé.
export const SOURCES = ["search", "favorites", "direct", "partner"];
const sourceKey = (advertId) => `acadeclic:origine:${advertId}`;
const sessionStore = () => {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch (e) {
    return null;
  }
};
const read = (storage, advertId) => {
  try {
    const value = storage?.getItem(sourceKey(advertId));
    return SOURCES.includes(value) ? value : null;
  } catch (e) {
    return null;
  }
};

// Origine retenue pour cette fiche dans l'onglet (avant d'aller réserver sans passer par la fiche)
export const rememberSource = (advertId, source, storage = sessionStore()) => {
  if (!advertId || !SOURCES.includes(source)) return;
  try {
    storage?.setItem(sourceKey(advertId), source);
  } catch (e) {
    // Stockage indisponible : la réservation partira sans origine
  }
};

// À l'ouverture de la fiche : origine du lien suivi (état de navigation), sinon lien partenaire,
// sinon celle déjà retenue dans l'onglet, sinon lien direct ; retenue pour la suite
export const resolveFicheSource = (advertId, { state, search = "", storage = sessionStore() } = {}) => {
  const fromLink = SOURCES.includes(state?.source) ? state.source : new URLSearchParams(search).get("via") === "partenaire" ? "partner" : null;
  const source = fromLink || read(storage, advertId) || "direct";
  rememberSource(advertId, source, storage);
  return source;
};

// Origine à joindre à une demande ou à une réservation (absente si l'onglet n'en a pas retenu)
export const bookingSource = (advertId, storage = sessionStore()) => read(storage, advertId) || undefined;
